import { useRef, useEffect } from "react";
import cx from "classnames";
import Typed from "typed.js";
import PropTypes from "prop-types";

const TypedText = ({ leftText, typedText, rightText, strings, textPosition }) => {
  const el = useRef(null);
  const typed = useRef(null);

  useEffect(() => {
    const options = {
      strings: [typedText, ...strings.filter((s) => s !== typedText)],
      loop: true,
      typeSpeed: 60,
      backSpeed: 60,
      showCursor: false,
    };

    // elRef refers to the <span> rendered below
    typed.current = new Typed(el.current, options);

    return () => {
      typed.current.destroy();
    };
  }, [strings]);

  return (
    <h1
      className={cx(
        "is-h1 max-w-4xl whitespace-nowrap py-6 text-4xl font-medium text-accent-100 md:text-5xl ",
        textPosition === "center" ? "mx-auto" : null
      )}
    >
      <span className="block">
        {leftText}
        <span className="typed-text whitespace-nowrap font-medium" ref={el} />
      </span>
      <span>{rightText}</span>
    </h1>
  );
};

TypedText.propTypes = {
  leftText: PropTypes.string,
  typedText: PropTypes.string,
  rightText: PropTypes.string,
  strings: PropTypes.arrayOf(PropTypes.string),
  textPosition: PropTypes.oneOf(["left", "right", "center"]),
};

export default TypedText;
